function hash(string) {
    let result = 5381;
    for (let index = 0; index < string.length; index++) {
        result = (result * 33) ^ string.charCodeAt(index);
    }
    return result >>> 0;
}
export function resolveToastId(type, message, options) {
    if (options?.id)
        return options.id;
    if (typeof message === 'string')
        return `toast-${type}-${hash(message)}`;
    return undefined;
}
